import type { FlagImports } from './types';
import {
  US,
  DE,
  BG,
  FR,
  IT,
  ES,
  TR,
  NL,
  PL,
  PT,
  NO,
  RO,
  DK,
  SE,
  CZ,
  RU,
  SK,
  CN,
  VN,
  FI,
  IE,
  LT,
  LV,
  EE,
  HR,
  HU,
} from 'country-flag-icons/string/3x2';

export const flagImports: FlagImports = {
  en: US as string,
  de: DE as string,
  bg: BG as string,
  fr: FR as string,
  it: IT as string,
  es: ES as string,
  tr: TR as string,
  nl: NL as string,
  pl: PL as string,
  pt: PT as string,
  nn: NO as string,
  ro: RO as string,
  se: SE as string,
  cz: CZ as string,
  ru: RU as string,
  sk: SK as string,
  cn: CN as string,
  vn: VN as string,
  fi: FI as string,
  lt: LT as string,
  lv: LV as string,
  ee: EE as string,
  hr: HR as string,
  hu: HU as string,
  da: DK as string,
  ga: IE as string,
  et: EE as string,
};
